import React from 'react';

interface SvgIconProps {
  svg: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  fill?: string;
  width?: number;
  height?: number;
}

const SvgIcon: React.FC<SvgIconProps> = ({ svg: SvgComponent, fill = '#000000', width = 24, height = 24 }) => {
  return <SvgComponent style={{ color: fill }} width={width} height={height} />;
};

export default SvgIcon;
